import { Component, OnInit } from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {Subject} from 'rxjs/Subject';
import {FormBuilder} from '@angular/forms';

@Component({
  selector: 'app-modal-generic-note',
  templateUrl: './modal-generic-note.component.html'
})
export class ModalGenericNoteComponent implements OnInit {
  regularForm
  options: any = {
    buttons: []
  };
  public onClose: Subject<any>;

  constructor(
    public bsModalRef: BsModalRef,
    private fb: FormBuilder,

  ) {
    this.onClose = new Subject();
  }

  ngOnInit() {
    this.regularForm =  this.fb.group({
      note: [null],
    }, {
      updateOn: 'blur',
    });
  }

  clickedButton(button: any) {
    if (this.options.isNavigate) {
      if (button === 'Rimani') {
        this.onClose.next(false);
      } else {
        this.onClose.next(true);
      }
    } else {
      let res = {
        button: button,
        note: this.regularForm.get('note').value
      }
      this.onClose.next(res);
    }
    this.bsModalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/modal-generic-note/modal-generic-note.component.ts